<template>
    <div>
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.danjia2 }}</h3>
            <Tag color="success">币别</Tag>


            <div style="margin-left: auto">
                <Button size="small" @click="addTable(pincheModel)">新增表格</Button>
            </div>
        </div>
        <div id="itemList" v-for="(item, row) in itemData.list" :key="row">
            <div class="fenleibiaoti">
                <unitBox :unit="item.unit" :units="units" @on-change="unitChange(item, $event)">
                </unitBox>
                <Tag color="success">币别</Tag>
                <currency v-model="item.currency"></currency>
                <Tag color="blue">起步价</Tag>
                <InputNumber size="small" v-model="item.startPirce"></InputNumber>
                <Tag color="blue">起步价(进口)</Tag>
                <InputNumber size="small" v-model="item.startPirceIn"></InputNumber>

                <div style="margin-left: auto">
                    <Button size="small" @click="copyTable(item, row)">复制表格</Button>
                    <Button size="small" @click="delTable(row)">删除表格</Button>
                </div>
            </div>

            <div class="priceTable">
                <div>
                    <p :style="{ height: item.unit.length*25+10 + 'px' }">
                        <moreLine :readonly="true" v-model="item.unit"> </moreLine>
                    </p>
                    <p :style="{ height: item.unit.length*25+10 + 'px' }">
                        <start-addend-add :startAdd="item.startAdd" :endAdd="item.endAdd"
                            :transportType="item.transportType" @start="item.startAdd = $event"
                            @end="item.endAdd = $event" @transportType="item.transportType = $event"></start-addend-add>

                    </p>
                </div>
                <div v-for="(x, col) in item.list" :key="col">
                    <p :style="{ height: item.unit.length*25+10 + 'px' }">
                        <moreLine v-model="x.unit"> </moreLine>
                    </p>

                    <p :style="{ height: item.unit.length*25+10 + 'px' }">
                        <rangeDanjia v-model="x.function" :now="item.unit"></rangeDanjia>
                    </p>
                    <div style="margin-top: 4px;" v-show="isUpdate">
                        <Button title="新增列" icon="md-add" size="small" type="success"
                            @click="addCol(col, item.list)"></Button>
                        <Button title="删除列" icon="md-close" size="small" type="success"
                            @click="delCol(col, item.list)"></Button>
                        <Button title="往前移" icon="md-arrow-round-back" size="small" type="primary"
                            @click="prevCol(col, item.list)"></Button>
                        <Button title="往后移" icon="md-arrow-forward" size="small" type="primary"
                            @click="nextCol(col, item.list)"></Button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import modelData from "../baojia/modelData";
import currency from "../baojia/currency.vue";
import unitBoxDanjia from "../baojia/unitBoxDanjia.vue";
import startAddendAdd from "../baojia/startAddendAdd.vue";
import moreLine from "../baojia/moreLine.vue";
import formula from "../baojia/formula.vue";
import unitBox from "../baojia/unitBox.vue";
import rangeDanjia from "../gongshi/rangeDanjia.vue";

export default {
    props: ["data",],
    components: { unitBox, unitBoxDanjia, rangeDanjia, startAddendAdd, currency, moreLine, formula },
    data() {
        return {
            isUpdate: true,
            zidian: modelData.zidian,
            itemData: {
                bulkPrice: {
                    "startPirce": 0,
                    "pl": 0,
                    "kgs": 0,
                    "cbm": 0,
                    "ctn": 0
                },

                list: [],
                startPirce: 0,
                currency: ""
            },
            units: [
                {
                    name: "KGS",
                    select: true,
                },
                {
                    name: "CBM",
                    select: true,
                },
                {
                    name: "P/L",
                    select: true,
                },
            ],
            gongshi: {
                1: "danjia(0,'份','人民币')",
                2: "huoZhi(0/10000,0,'港元')",
            },
            pincheModel: modelData.pincheModel
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
            this.funTo();
        },
        getVal() {
            this.toFun();
            return this.itemData;
        },
        unitChange(item, abc) {

            var index = 0;
            for (let m = 0; m < item.unit.length; m++) {
                if (abc.name == item.unit[m]) {
                    index = m;
                }
            }
            var select = abc.select;
            var name = abc.name;
            var list = item.list;
            if (select) {
                //选中，添加回来
                item.unit.push(name);
                for (let i = 0; i < list.length; i++) {
                    list[i].unit.push("0-0");
                }
            } else {
                //取消选中。删除

                item.unit.splice(index, 1);
                for (let i = 0; i < list.length; i++) {
                    list[i].unit.splice(index, 1);
                }
            }
        },
        addTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            //list.splice(index, 0, obj);
            this.itemData.list.unshift(JSON.parse(JSON.stringify(obj)));
        },
        copyTable(v, index) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            this.itemData.list.splice(index, 0, JSON.parse(JSON.stringify(obj)));
        },
        delTable(row) {
            if (this.itemData.list.length == 1) {
                this.$Message.info('至少保留一个表格')
                return;
            }
            this.itemData.list.splice(row, 1)
        },
        //xinde
        delCol(index, list) {
            if (list.length == 1) {
                this.$Message.info('至少保留一列')
                return;
            }
            list.splice(index, 1);
        },
        addCol(index, list) {
            var m = list[index];
            list.splice(index, 0, JSON.parse(JSON.stringify(m)));

        },
        prevCol(index, list) {
            if (index == 0) {
                return;
            }
            var m = list[index];
            list.splice(index, 1);
            //setTimeout(() => {
            list.splice(index - 1, 0, m);
            //}, 5000);
        },
        nextCol(index, list) {
            if (index == list.length) {
                return;
            }
            var m = list[index];
            list.splice(index, 1);
            //setTimeout(() => {
            list.splice(index + 1, 0, m);
        },
        //转化成函数
        toFun() {
            var t = this.itemData.list;
            for (let i = 0; i < t.length; i++) {
                t[i].function = "danjiaPrice(" +
                    t[i].startPirce + "," +
                    t[i].startPirceIn + ")"

            }

        },
        //函数转化为字段
        funTo() {
            var t = this.itemData.list;
            for (let i = 0; i < t.length; i++) {
                var k = eval('this.' + t[i].function);

                t[i].startPirce = k.a;
                t[i].startPirceIn = k.b;
            }

        },
        danjiaPrice(a, b) {
            return { a, b }
        },
    },
    mounted() {
        this.tt();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/danjia2.vue